import React from 'react';
import { HomeIcon, ArrowsRightLeftIcon, WalletIcon, BanknotesIcon } from '@heroicons/react/24/solid';
import SharedNavbarBottom from 'shared_items/NavbarBottom';

// Wrapper de compatibilidade — preserva a assinatura original (activeTabL2).
// Implementação real em shared_items/NavbarBottom.jsx (design-system fase 2). Remover em fase 3.
const TABS = [
  { key: 'home', label: 'Home', Icon: HomeIcon },
  { key: 'flow', label: 'Flow', Icon: ArrowsRightLeftIcon },
  { key: 'budget', label: 'Budget', Icon: WalletIcon },
  { key: 'assets', label: 'Assets', Icon: BanknotesIcon },
];

const NavbarBottom = ({ activeTabL2, handleTabChange }) => (
  <SharedNavbarBottom
    tabs={TABS}
    activeTab={activeTabL2}
    onTabChange={handleTabChange}
    moduleKey="finance"
    zIndexClass="z-10"
  />
);

export default NavbarBottom;
